import Breadcrumb from "../../../helper/Breadcrumb";
import { Suspense, useState } from "react";
import SearchCatalogueTable from "./components/SearchCatalogueTable";
import SearchProductTable from "./components/SearchProductTable";
import axiosInstance from "../../../axiosInterceptor";
import {
 searchProductColumnsList,
 searchCatalogueColumnsList,
} from "../../../Data/columnsData";
import {
 deleteItem,
 deleteMultipleItem,
 toggleStatus,
} from "../../../utils/apiUtils";
import DeleteModel, {
 confirmBulkDelete,
} from "../../../Components/DeleteModel";
import { DeleteButton } from "../../../helper/ImageFormat";
const breadcrumbdata = [
 { label: "Home", path: "/" },
 { label: "Search", path: "/search" },
];

const Search = () => {
 const [hasSearched, setHasSearched] = useState(false);
 const [stockLoadingIds, setStockLoadingIds] = useState(new Set());
 const [search, setSearch] = useState("");
 const [isDeleting, setIsDeleting] = useState(false);
 const [data, setData] = useState([]);
 const [loading, setLoading] = useState(false);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [currentPage, setCurrentPage] = useState(1);
 const perPage = 10;
 const [totalPages, setTotalPages] = useState(1);
 const [totalCount, setTotalCount] = useState(0);
 const [selected, setSelected] = useState([]);
 const fetchData = async () => {
  try {
   setLoading(true);

   const payload = {
    search,
    perPage,
    pageNo: currentPage,
   };

   const res = await axiosInstance.post("/search-product", payload);

   setData(res?.data?.data || []);

   setTotalPages(res?.data?.totalPages || 1);
   setTotalCount(res?.data?.totalCount || 0);
  } catch (err) {
   return null;
  } finally {
   setLoading(false);
  }
 };

 const handleSearch = () => {
  setHasSearched(true);
  setCurrentPage(1);
  fetchData();
 };
 const handlePageClick = (page) => {
  setCurrentPage(page);
  setTimeout(() => {
   fetchData();
  }, 0);
 };

 const handleStatusToggle = async (item) => {
  const isCatalogue = item?.type === "catalogue";

  const url = isCatalogue ? "catalogue-status" : "product-status";

  const updatedData = await toggleStatus(url, item?.id, fetchData);

  if (Object.keys(updatedData).length > 0) {
   setData((prev) =>
    prev.map((curr) => {
     // Normal catalogue / product

     if (curr.id === updatedData.id) {
      return {
       ...curr,
       isActive: updatedData.isActive,
      };
     }

     // Catalogue ke andar products

     if (curr.products?.length) {
      return {
       ...curr,

       products: curr.products.map((product) => {
        if (product.id === updatedData.id) {
         return {
          ...product,

          isActive: updatedData.isActive,
         };
        }

        return product;
       }),
      };
     }

     return curr;
    })
   );
  }
 };
 const handleStockToggle = async (item) => {
  if (stockLoadingIds.has(item.id)) return;
  setStockLoadingIds((prev) => new Set([...prev, item.id]));
  try {
   const url =
    item.type === "catalogue" ? "/catalogue-stock" : "/product-stock";
   const res = await axiosInstance.put(`${url}/${item.id}`, {
    isOutOfStock: !item.outofStock,
   });
   const updatedData = res.data.data;
   setData((prev) =>
    prev.map((curr) => {
     // normal product
     if (curr.id === updatedData.id) {
      return {
       ...curr,
       outofStock: updatedData.outofStock,
      };
     }

     // catalogue ke andar product
     if (curr.products?.length) {
      return {
       ...curr,

       products: curr.products.map((product) => {
        if (product.id === updatedData.id) {
         return {
          ...product,
          outofStock: updatedData.outofStock,
         };
        }

        return product;
       }),
      };
     }

     return curr;
    })
   );
  } catch (error) {
   console.log(error);
  } finally {
   setStockLoadingIds((prev) => {
    const updated = new Set(prev);

    updated.delete(item.id);

    return updated;
   });
  }
 };

 const confirmDelete = async () => {
  setIsDeleting(true);

  try {
   const url = deleteItemId?.type === "catalogue" ? "catalogue" : "product";

   const res = await deleteItem(url, deleteItemId?.id);

   if (res) {
    setData((prev) =>
     prev
      .filter((curr) => {
       // top level delete
       if (curr.id === deleteItemId.id) {
        return false;
       }

       return true;
      })
      .map((curr) => {
       // catalogue ke andar product delete

       if (curr.products?.length) {
        return {
         ...curr,

         products: curr.products.filter(
          (product) => product.id !== deleteItemId.id
         ),

         no_of_product: curr.products.filter(
          (product) => product.id !== deleteItemId.id
         ).length,
        };
       }

       return curr;
      })
    );
   }

   setDeleteItemId({});

   setDeleteModalOpen(false);

   return res;
  } catch (error) {
    return error;
   return error;
  } finally {
   setIsDeleting(false);
  }
 };
 const productData = data.filter((item) => item.type === "product");
 const catalogueData = data.filter((item) => item.type === "catalogue");

 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };

 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="custom-page-title">Catalogue</h3>
    <Breadcrumb items={breadcrumbdata} />
   </div>
   <div
    className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
    style={{
     background: "#fff",
     padding: "14px 16px",
     borderRadius: "10px",
     boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    }}
   >
    <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
     <input
      type="text"
      value={search}
      placeholder="Search products or catalogue..."
      onChange={(e) => setSearch(e.target.value)}
      className="form-control"
      style={{
       maxWidth: "300px",
       height: "38px",
       borderRadius: "8px",
      }}
       onKeyDown={(e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  }}
     />
    </div>

    <div className="d-flex align-items-center" style={{ gap: "15px" }}>
     <button
      onClick={handleSearch}
      disabled={!search.trim()}
      className="btn btn-info"
      style={{
       height: "38px",
       borderRadius: "8px",
       padding: "0 18px",
       fontWeight: "500",
       opacity: !search.trim() ? 0.6 : 1,
       cursor: !search.trim() ? "not-allowed" : "pointer",
      }}
     >
      Search
     </button>
    </div>
   </div>
   {productData.length > 0 && (
    <>
     <div
      style={{
       background: "#fff",
       padding: "12px 16px",
       marginTop: "0px",
       marginBottom: "5px",
      }}
     >
      <h4 className="mb-0">Selection</h4>
     </div>

     <SearchProductTable
      loading={loading}
      productData={productData}
      currentPage={currentPage}
      perPage={perPage}
      totalPages={totalPages}
      totalCount={productData.length}
      handlePageClick={handlePageClick}
      columnsList={searchProductColumnsList}
      handleStatusToggle={handleStatusToggle}
      handleStockToggle={handleStockToggle}
      handleDelete={handleDelete}
      setSelected={setSelected}
      stockLoadingIds={stockLoadingIds.has(data.id)}
      selected={selected}
     />
    </>
   )}
   {catalogueData.length > 0 && (
    <>
     <div
      style={{
       background: "#fff",
       padding: "12px 16px",
       marginTop: "0px",
       marginBottom: "5px",
      }}
     >
      <h4 className="mb-0">Full Set</h4>
     </div>

     <SearchCatalogueTable
      loading={loading}
      productData={catalogueData}
      currentPage={currentPage}
      perPage={perPage}
      totalPages={totalPages}
      totalCount={catalogueData.length}
      handlePageClick={handlePageClick}
      handleStatusToggle={handleStatusToggle}
      columnsList={searchCatalogueColumnsList}
      handleDelete={handleDelete}
      handleStockToggle={handleStockToggle}
      setSelected={setSelected}
      selected={selected}
      stockLoadingIds={stockLoadingIds.has(data.id)}
     />
    </>
   )}

   {deleteModalOpen && (
 <Suspense fallback={null}>

  <DeleteModel
   deleteModalOpen={deleteModalOpen}
   setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
   onConfirm={confirmDelete}
   itemName={
    deleteItemId?.type === "catalogue"
     ? "Catalogue"
     : "Product"
   }
   isDeleting={isDeleting}
  />

 </Suspense>
)}

   {hasSearched && !loading && data.length === 0 && (
    <div
     className="text-center"
     style={{
      background: "#fff",
      padding: "40px 20px",
      borderRadius: "10px",
      marginTop: "10px",
     }}
    >
     <h5
      style={{
       margin: 0,
       color: "#6c757d",
       fontWeight: "500",
      }}
     >
      Data Not Found
     </h5>
    </div>
   )}
  </div>
 );
};

export default Search;
